export default __webpack_public_path__ + "static/media/Logo_Stacked_Color.2672bb2d.png";